import type { RequestReportForm } from "@nlc/shared-types";

import { useMutation } from "@tanstack/react-query";

import { useGetRequest } from "@/hooks/useGetRequest.tsx";
import apiClient from "@/lib/api/client";

export function useRequestReport() {
  const { data: request } = useGetRequest();
  const requestId = request?.id;

  return useMutation({
    mutationFn: async (data: RequestReportForm) =>
      apiClient.url(`/requests/${requestId}/report`).post(data).json(),
  });
}
